Vue.component('vue-simple-suggest', VueSimpleSuggest);
import VueSimpleSuggest from 'vue-simple-suggest';
window.VueSimpleSuggest = VueSimpleSuggest;